<div class="settings-page">
    <div class="settings-page__content">
        <div class="settings-card">
            <div class="settings-card__header">
                <img src="/assets/images/Group 24.svg" alt="" />
                <div class="settings-card__header-headline">
                    <h2>Bine ați venit</h2>
                    <h4>Setări Generale - Ghișeul Unic</h4>
                </div>
            </div>
        </div>
    </div>

    <div class="content-box">
        <div class="settings-page-container">
            <mat-button-toggle-group [value]="selectedComponent" (change)="onChange($event)"
                class="settings-page_menu ">
                <mat-button-toggle [value]="option" class="settings-page_menu-item "
                    *ngFor="let option of filteredComponents">
                    {{ option }}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div class="settings-page__content">
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.PRIORITY">
                <app-priorities> </app-priorities>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.STATUS">
                <app-status> </app-status>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.TIPURI_PROGRAM_ACTIVE">
                <app-tip-program-active> </app-tip-program-active>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.MODULE">
                <app-ghiseu-module> </app-ghiseu-module>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.LOCATII">
                <app-locatii> </app-locatii>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.SERVICII">
                <app-servicii> </app-servicii>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.MODULE_LOCATII_ACTIVE">
                <app-module-locatii> </app-module-locatii>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.LOCATII_SERVICII_ACTIVE">
                <app-locatii-servicii> </app-locatii-servicii>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.MODULE_LOCATII_SERVICII_ACTIVE">
                <app-mod-loc-servicii> </app-mod-loc-servicii>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.PROGRAMARI_SLOTURI_BLOCARE">
                <app-programari-blocare> </app-programari-blocare>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.PROGRAMARI_SLOTURI_ULTIMA_ORA">
                <app-programari-ultima-ora> </app-programari-ultima-ora>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.TIPURI_PROGRAM">
                <app-tip-program> </app-tip-program>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.TIPURI_PROBLEMA">
                <app-tip-problema> </app-tip-problema>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.TIPURI_PROBLEMA_SERVICII_ACTIVE">
                <app-tip-problema-servicii> </app-tip-problema-servicii>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.OPERATORI">
                <app-operatori> </app-operatori>
            </ng-container>
            <ng-container *ngIf="selectedComponent === GhiseulUnicSettingsSidebar.ZILE_LIBERE">
                <app-zile-libere> </app-zile-libere>
            </ng-container>

            <div class="row" *ngIf="selectedComponent == null">
                <div class="col-sm-12 py-5">
                    <div class="row h-100 justify-content-center align-items-center">
                        <div class="col-12 text-center">
                            <div class="py-3">
                                <p class="mb-0">Selectați o secțiune</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>